import { defineComponent as _defineComponent } from 'vue'
import type { Provision } from '@/helpers/composables/useArticle';

import { ProfileType } from '@/@types/graphql-types';

import ProfileBox from '@/features/user-profile/components/ProfileBox.vue';
import { influencerIds } from '@/features/user-profile/types';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorBox',
  props: {
    author: null,
    hideBadge: null,
    size: null,
    hideAllBadges: { type: Boolean },
    isBadgeInline: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	author: Provision['author'];

	/* Array of profile types for which to hide the badge. */
	hideBadge?: ProfileType[];

	/* Determines size of author avatar, and style of author name */
	size?: 'xsmall' | 'small' | 'large';

	/* Disable badges for all profile types. */
	hideAllBadges?: boolean;

	/** Whether to make the badge inline (row) or not. */
	isBadgeInline?: boolean;
};



const profileType = computed(() =>
	influencerIds.includes(props.author.id) ? ProfileType.Influencer : ProfileType.JwEditor
);

const profile = computed(() => ({
	__typename: 'Profile' as const,
	id: props.author.id,
	profileUrl: props.author.content.fullPath,
	avatarUrl: props.author.content.imageUrl,
	displayName: props.author.content.clearName,
	// Currently Editor's pick is the only place still getting profiles through author
	// Editorial areas still depend on author for now
	profileType: profileType.value,
}));

return { __sfc: true,props, profileType, profile, ProfileBox }
}

})